import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';

// Storage key for chat position (shared with ChatPanel)
const CHAT_POSITION_KEY = 'kineserve-chat-position';

export const FloatingChatButton = ({ onClick }) => {
  const [position, setPosition] = useState('right');
  const [isHovered, setIsHovered] = useState(false);

  // Load position from localStorage
  useEffect(() => {
    const savedPosition = localStorage.getItem(CHAT_POSITION_KEY);
    if (savedPosition) {
      setPosition(savedPosition);
    }
    
    // Listen for storage changes (when ChatPanel updates position)
    const handleStorageChange = (e) => {
      if (e.key === CHAT_POSITION_KEY && e.newValue) {
        setPosition(e.newValue);
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    // Also poll localStorage for changes within same tab
    const interval = setInterval(() => {
      const current = localStorage.getItem(CHAT_POSITION_KEY);
      if (current && current !== position) {
        setPosition(current);
      }
    }, 500);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [position]);

  const positionClass = position === 'right' ? 'right-4' : 'left-4';

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`fixed bottom-4 ${positionClass} z-50 flex flex-col items-center justify-center bg-primary/90 hover:bg-primary text-primary-foreground shadow-lg transition-all duration-300 ease-in-out rounded-2xl ${
        isHovered 
          ? 'px-3 py-2' 
          : 'px-2 py-1.5'
      }`}
      aria-label="Open chat with Amie"
      data-testid="floating-chat-button"
    >
      <div className="relative flex-shrink-0">
        <img 
          src="/amie-icon.jpg" 
          alt="Amie Assistant" 
          className={`rounded-full transition-all duration-300 ${isHovered ? 'w-8 h-8' : 'w-6 h-6'}`}
        />
        <div className={`absolute -top-0.5 -right-0.5 bg-green-500 rounded-full border border-white ${isHovered ? 'w-2 h-2' : 'w-1.5 h-1.5'}`}>
          <span className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-75"></span>
        </div>
      </div>
      
      {/* Text below the icon */}
      <span className={`font-medium whitespace-nowrap transition-all duration-300 ${
        isHovered 
          ? 'text-xs mt-1' 
          : 'text-[10px] mt-0.5'
      }`}>
        {isHovered ? 'Amie - Your assistant' : 'Amie'}
      </span>
    </button>
  );
};